import { render } from "./CustomerCart.vue?vue&type=template&id=66930140&scoped=true&ts=true"
import script from "./CustomerCart.vue?vue&type=script&lang=ts"
export * from "./CustomerCart.vue?vue&type=script&lang=ts"

import "./CustomerCart.vue?vue&type=style&index=0&id=66930140&scoped=true&lang=css"

import exportComponent from "/home/uat/uatdan_yrshop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66930140"]])

export default __exports__